import { take, put, call } from 'redux-saga/effects'
import { request, getSsoUserInfo } from '../utils/request'

const path = window.location.pathname.split("/");
const articleId = path[2];
const needLogin = !global.noAuth && path[1] === "article" && !!articleId;

export function* getUserInfo() {

  yield put({
    type: "session/getSsoUserInfo",
    promise: getSsoUserInfo(),
  });
  
  yield take("session/getSsoUserInfo");

  yield put({
    type: "session/getUserInfo",
    promise: request("/user/current"),
  });
}


export function* getComments() {
  if (needLogin) {

    let i = 0;
    while (++i) {
      if (i !== 1) {
        yield take("comment/onCommentSuc")
      }
      yield call((t => new Promise(resolve => setTimeout(resolve, t))), 500)
      yield put({
        type: "comment/getCommentList",
        promise: request("/get_comments", { body: { id: articleId } })
      });
    }

  }

}

// export function *makePraise() {
//   if (needLogin){
//     yield take("comment/onPraise");
//     yield call(request, `/give_praise/${articleId}`, {method: "post"})
//   }
// }


// WEBPACK FOOTER //
// ./src/sagas/session.ts